import type { Role } from '@/entities/user';

/** Admin darkstores API is SUPER_ADMIN-only; dashboard maps `admin`. */
export const storesAccessRoles = ['admin'] as const satisfies readonly Role[];
